import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBarsSortDown = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12.286 27.715a1.285 1.285 0 0 0-.909 2.194l7.714 7.714a1.285 1.285 0 0 0 1.818 0l7.714-7.714a1.285 1.285 0 1 0-1.817-1.818l-5.52 5.52V3.285A1.29 1.29 0 0 0 20 2c-.707 0-1.286.575-1.286 1.286V33.61l-5.52-5.52a1.293 1.293 0 0 0-.908-.375Z" })
});
export default SvgBarsSortDown;
